import React, { useState, useCallback, useMemo } from "react";
import debounce from "lodash/debounce";
import classNames from "classnames";

export type Props = {
  value?: string;
  onChange?: (val: any) => void;
  className?: string;
  debounceTimeout?: number;
  placeholder?: string;
  type?: string;
  error?: string | boolean;
  isFilter?: boolean;
};

function DebounceInput({
  value,
  onChange,
  debounceTimeout = 300,
  type = 'text',
  className,
  error,
  isFilter,
  ...inputProps
}: Props) {
  const [localValue, setValue] = useState(value);

  const setDebouncedChange = useMemo(
    () =>
      onChange
        ? debounce((val) => {
            onChange(val);
            setValue(undefined);
          }, debounceTimeout)
        : null,
    [onChange, debounceTimeout]
  );

  const handleInputChange = useCallback(
    (e: any) => {
      setValue(e.target.value);
      if (setDebouncedChange) setDebouncedChange(e.target.value);
    },
    [setDebouncedChange]
  );

  return (
    <input
      autoComplete="new-password"
      {...inputProps}
      className={classNames(error ? 'error-input' : 'text-input', className)}
      type={type}
      value={localValue ?? (value || '')}
      onChange={handleInputChange}
    />
  );
}

export default DebounceInput;
